import React from "react";
import ProductsCard from "../card/ProductsCard";

const ProductsFromModel = ({ title, data }) => {
  return (
    <>
      {" "}
      <h3 className="title">{title}</h3>
      <div className="grid grid-cols-3 xl:grid-cols-4 gap-5 mt-4">
        {data?.map((e) => (
          <span>
            <ProductsCard data={e} />
          </span>
        ))}
      </div>
    </>
  );
};

export default ProductsFromModel;
